import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { Grid } from '@/common/grid/Grid';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useRef, useState } from 'react';

export const McdInvPrioritizationGrid = ({ formValues, endDateToStartDate, idToMcdInvOrigin }) => {

  const { invPeriodId, stateIds, ctrtIds, checkRunDates, mcdInvOriginIds } = formValues;

  const rsrc = useRsrc();
  const gridRef = useRef();
  const { navigateTo } = useNavState();

  const [data, setData] = useState([]);
  const [fieldDefs, setFieldDefs] = useState();

  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {

    let fieldDefs = [
      { field: 'stateCode', displayName: 'State', module: 'md', entity: 'STATE', type: 'HYPERLINK', },
      { field: 'ctrtCode', displayName: 'Contract', module: 'md', entity: 'CTRT', type: 'HYPERLINK', },
      { field: 'minStatusDisplay', displayName: 'Minimum Status'},
      { field: 'dueAmt', displayName: 'Due Amount', type: 'MONEY', sort: 'desc' },
      { field: 'dispAmt', displayName: 'Disputed Amount',  type: 'MONEY' }
    ];

    setFieldDefs(fieldDefs)
  }, []);

  useEffect(() => {
    if (!invPeriodId) return;

    const endDate = Math.max(...checkRunDates);
    const minEndDate = Math.min(...checkRunDates);
    const startDate = endDateToStartDate[minEndDate];// Filter out any ids that don't have a corresponding name in the map
    const reqParam = {
      periodId: invPeriodId,
      stateIds,
      ctrtIds,
      startDate,
      endDate,
      mcdInvOriginNames: mcdInvOriginIds.map(id => idToMcdInvOrigin[id]),
    };
    rsrc.data('sc', 'MCD_INV_PRIORITIZATION_GRID_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [invPeriodId, stateIds, ctrtIds, checkRunDates, mcdInvOriginIds]);

  useEffect(() => {
    setIsGridReady(false);
  }, [fieldDefs]);

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
      gridRef.current.setDataSource(data);
    }
  }, [isGridReady, data]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  const getContextMenuItems = (params) => {
    let contextMenus = [];

    contextMenus.push(
      {
        name: 'Navigate to Invoices',
        action: () => navigateToInvs(params),
        icon: fas.faInfoCircle                                                         
      }
    );
    return contextMenus;
  }

  const navigateToInvs= (params) => {
    let stateId = params.node.data.stateId;
    let ctrtId = params.node.data.ctrtId;
    let invPeriodId = params.node.data.invPeriodId;

    let expr = ExprUtils.whereParams('stateId',stateId, 'ctrtId', ctrtId, 'invPeriodId', invPeriodId);
    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };

    navigateTo('/sc/mcd-inv', navState);
  }

  if (!fieldDefs) return;
  return (
    <>
      <Grid
        key={JSON.stringify(fieldDefs)}
        ref={gridRef}
        gridOptions={{
          fieldDefs,
          rowModelType: 'clientSide',
          getContextMenuItems
        }}
        events={{
          onGridReady,
        }}
      />
    </>
  );
};
